import { dateUtils } from "@/arad/core/utilities";
import type { App, Plugin } from "vue";

export const datePlugin: Plugin = {
  install(app: App) {
    app.config.globalProperties.$date = dateUtils;
  }
};




